import axiosInstance from '@/utils/api.js'

var state = {
  additional: [],
  core_time_zone: []
}

var getters = {
  ADDITIONAL: (state) => {
    return state.additional
  },
  CORE_TIME: (state) => {
    return state.core_time_zone
  }
}

var mutations = {
  SET_ADDITIONAL: (state, payload) => {
    state.additional = payload
  },
  SET_CORE_TIME: (state, payload) => {
    state.core_time_zone = payload
  }
}

var actions = {
  GET_ADDITIONAL: async (context, payload) => {
    let result = await axiosInstance.get('/settings/additionalparams')
    if (result.status === 200) {
      context.commit('SET_ADDITIONAL', result.data)
    }
  },
  GET_CORE_TIME_ZONE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/core_time')
    if (result.status === 200) {
      context.commit('SET_CORE_TIME', result.data)
      // let gmtOffset_ = Number(result.data.tm_gmtoff) / 60 / 60
      let gmtOffset_ = Number(result.data.tm_gmtoff)
      if (localStorage.getItem('tz_selected') === 'CoreTZ') {
        context.dispatch('SET_TIMEZONE_DELTA', { tz: gmtOffset_, tz_selected: 'CoreTZ' })
      }
    }
  },
  SET_TIMEZONE_DELTA: (context, payload) => {
    const d = new Date()
    let secInMin = 60
    let minInHour = 60
    let timeOffsetSec = d.getTimezoneOffset() * secInMin * (-1) // GMT offset straight sign
    let timeOffsetMin = d.getTimezoneOffset() * (-1) // GMT offset straight sign

    let selectedTZsec = payload.tz * minInHour * secInMin // in seconds

    localStorage.setItem('tz_selected', payload.tz_selected)
    let SelectedSubsLocalOffset = selectedTZsec - timeOffsetSec
    // gmt_offset_min
    //
    if (payload.tz_selected === 'CustomTZ') {
      localStorage.setItem('tzDelta', selectedTZsec - timeOffsetSec)
      localStorage.setItem('gmt_offset_min', (payload.tz * 60))
      localStorage.setItem('selectedOffset-local', SelectedSubsLocalOffset)
    } else if (payload.tz_selected === 'CoreTZ') {
      localStorage.setItem('tzDelta', payload.tz - timeOffsetSec)
      localStorage.setItem('gmt_offset_min', (payload.tz / 60))
      localStorage.setItem('selectedOffset-local', payload.tz)
    } else if (payload.tz_selected === 'LocalTZ') {
      localStorage.setItem('tzDelta', 0)
      localStorage.setItem('gmt_offset_sec', timeOffsetSec)
      localStorage.setItem('gmt_offset_min', timeOffsetMin)
      localStorage.setItem('selectedOffset-local', 0)
    }
  },
  CREATE_ADDITIONAL: (context, payload) => {
    return axiosInstance.post('/settings/additionalparams', payload)
  },
  UPDATE_ADDITIONAL: (context, payload) => {
    return axiosInstance.put('/settings/additionalparams', payload)
  },
  DELETE_ADDITIONAL: (context, payload) => {
    return axiosInstance.delete('/settings/additionalparams?aparam_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/additional.js